module.exports = __webpack_public_path__ + "img/世界时钟.ca492388.png";